import { FAKE, REAL, registerDependency } from 'components/shared/dependency-injection/dependency-injection.js'
import type { TierPricing } from 'components/discovery/pdp/tier-pricing/typing/tier-pricing-typing.js'

export class GetTierPricingRequest {
  method = 'GET' as const
  headers: HeadersInit = { Accept: 'application/json' }
  endpointUrl: string

  constructor(endpointUrl: string) {
    this.endpointUrl = endpointUrl
  }
}

export interface TierPricingAPI {
  getTiers(request: GetTierPricingRequest): Promise<unknown>
}

export class FakeTierPricingAPI implements TierPricingAPI {
  requests: GetTierPricingRequest[] = []
  tiersData: TierPricing | null = null
  throws: Error | null = null

  getTiers(request: GetTierPricingRequest) {
    this.requests.push(request)
    if (this.throws) return Promise.reject(this.throws)
    return Promise.resolve(this.tiersData as TierPricing)
  }
}

export class RealTierPricingAPI implements TierPricingAPI {
  async getTiers(request: GetTierPricingRequest) {
    const response = await fetch(request.endpointUrl, { method: request.method, headers: request.headers })
    if (!response.ok) throw new Error(`Failed to fetch tier pricing (${response.status}): ${request.endpointUrl}`)
    return response.json()
  }
}

export let tierPricingApi!: TierPricingAPI
registerDependency({
  [REAL]: () => tierPricingApi = new RealTierPricingAPI(),
  [FAKE]: () => tierPricingApi = new FakeTierPricingAPI(),
})
